<template>
  <v-container fluid class="px-0 py-0">
    <v-responsive
    :style="{
      background: 'url(' + tileBackground +') no-repeat center center',
      height: '500px',
      width: '100%',
      '-webkit-background-size': 'cover',
      '-moz-background-size': 'cover',
      '-o-background-size': 'cover',
      'background-size': 'cover'
    }"

    class="pt-5">
      <v-container grid-list-xl>
        <v-layout wrap>
          <v-flex md5 offset-md1 class="mt-5">
            <v-card flat>
              <v-layout row wrap>
                <v-flex md6 class="ml-3">
                  <v-img :src="logoTrToolbox" max-width="300px"></v-img>
                </v-flex>
                <v-flex md12 class="ml-3 mr-3">
                  <p class="subheading">
                  The TR Toolbox is a set of easy-to-use and extremely powerful tools helping decision makers and analysts to better understand the TR industry.<br/>
                  We packaged advanced Data Science and Artificial Intelligence technologies inside a smart and simple user interface to help you solve widespread and daily challenges of the TR industry.<br/>
                  The TR Toolbox is the ideal first stop when looking for market intelligence and industry knowledge.
                </p>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
    <v-layout wrap row justify-center class="mt-5 px-2">
      <v-flex md3 class="pr-2">
        <p class="subheading">
          Endorsed by leading associations such as the <strong>Tax-Free World Association</strong> (TFWA), the <strong>Duty-Free World Council</strong> (DFWC) and its member associations, the TR Toolbox aims at systematising and automating daily tasks performed by business analysts and managers across the industry.
        </p>
<!--         <p class="subheading" style="text-align:center;">
          TFWA member ? <router-link to="/access">Discover your benefits</router-link>
        </p> -->
      </v-flex>
      <v-flex md1>
        <v-img :src="tfwaDfwc" width="180px" contain/>
      </v-flex>
    </v-layout>

    <v-layout wrap row justify-center class="px-2">
      <v-flex md3 class="pr-2">
        <p class="subheading">
          No installation required! The tools are available online through affordable subscriptions.<br/>
        </p>
<!--         <p class="subheading">
          The TR Toolbox currently offers two modules: the <a style="color: #F28704;" href="http://www.contineolabs.com/tr-searchengine" target="_blank" >TR Search Engine</a> and the <a style="color: #F28704;" href="http://www.contineolabs.com/tr-wiki" target="_blank">TR Wiki</a>.
        </p> -->
      </v-flex>
      <v-flex md1>
        <v-img :src="logoTrSeWiki" width="180px" contain/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'about',
  data () {
    return {
      tileBackground: require('../assets/AdobeStock_172421142_Preview-4k.jpg'), // eslint-disable-line no-undef
      logoTrSeWiki: require('../assets/Logo TR Search Engine & Wiki.png'), // eslint-disable-line no-undef
      logoContineo: require('../assets/Logo Contineo.png'), // eslint-disable-line no-undef
      logoTrToolbox: require('../assets/Logo TR Toolbox.png'), // eslint-disable-line no-undef
      tfwaDfwc: require('../assets/TFWA-DFWC.png'), // eslint-disable-line no-undef
      logoTfwa: require('../assets/TFWA.png') // eslint-disable-line no-undef
    }
  },
  computed: {
    ...mapState([
      'authenticated',
      'user'
    ])
  }
}
</script>
<style>
</style>